export enum HwTypeKey {
  // Virtualization
  LINUX = 'linux',
  VMWARE = 'vmware',
  PROXMOX = 'proxmox',
  NUTANIX = 'nutanix',
  POWER = 'power',
  MAINFRAME = 'mainframe',
  OVIRT = 'ovirt',
  XENSERVER = 'xenserver',
  WINDOWS = 'windows',
  SOLARIS = 'solaris',
  ORACLEVM = 'oraclevm',
  FUSIONCOMPUTE = 'fusioncompute',
  AS400 = 'as400',
  MORPHEUS = 'morpheus',
  GPU = 'gpu',

  // NOT SUPPORTED VIRTUALIZATION
  HUAWEI = 'fusioncompute',
  XEN = 'xenserver',
  CLOUDSTACK = 'cloudstack',

  // Service Processor
  HPEILO = 'hpeilo',
  DIDRAC = 'didrac',
  LXCLARITY = 'lxclarity',
  HPEONEVIEW = 'hpeoneview',

  // Database
  DB2 = 'db2',
  MONGODB = 'mongodb',
  ORACLEDB = 'oracledb',
  POSTGRES = 'postgres',
  SQLSERVER = 'sqlserver',
  TIMESCALEDB = 'timescaledb',

  // Storage
  _3PAR = '3par',
  COMPELLENT = 'compellent',
  DATADOMAIN = 'datadomain',
  DOTHILL = 'dothill',
  ESERIES = 'eseries',
  IBMCOSS = 'ibmcoss',
  ISILON = 'isilon',
  POWERFLEX = 'powerflex',
  RUBRIK = 'rubrik',
  STOREONCE = 'storeonce',
  SWIZ = 'swiz',
  SWIZFLASH = 'swizflash',
  QNAP = 'qnap',
  ORACLEZFS = 'oraclezfs',
  COHESITY = 'cohesity',
  VMAX = 'vmax',
  GPFS = 'gpfs',
  NETBACKUP = 'netbackup',
  MACROSAN = 'macrosan',
  METRONODE = 'metronode',
  CEPH = 'ceph',
  DATACORE = 'datacore',
  DS5K = 'ds5k',
  DS8K = 'ds8k',
  ECS = 'ecs',
  ETERNUS = 'eternus',
  EXAGRID = 'exagrid',
  FALCONSTOR = 'falconstor',
  TRUENAS = 'truenas',
  HCP = 'hcp',
  HNAS = 'hnas',
  HUS = 'hus',
  INFINIBOX = 'infinibox',
  NETAPP = 'netapp',
  NIMBLE = 'nimble',
  OCEANSTOR = 'oceanstor',
  PURE = 'pure',
  PUREBLADE = 'pureblade',
  QUMULO = 'qumulo',
  RAIDIX = 'raidix',
  SOLIDFIRE = 'solidfire',
  STOREVIRTUAL = 'storevirtual',
  SYNOLOGY = 'synology',
  VNX = 'vnx',
  VNXE = 'vnxe',
  VNXF = 'vnxf',
  VPLEX = 'vplex',
  VSPG = 'vspg',
  UNITY = 'unity',
  XIV = 'xiv',
  XTREMIO = 'xtremio',
  STORAGEGRID = 'storagegrid',
  POWERSTORE = 'powerstore',
  DDNINTELLIFLASH = 'ddnintelliflash',
  OCEANSTORPACIFIC = 'oceanstorpacific',
  OCEANSTORPACIFICNAS = 'oceanstorpacificnas',
  OCEANSTORNAS = 'oceanstornas',
  SCALITYRING = 'scalityring',

  // San
  SANBRCD = 'sanbrcd',
  SANBRCDRESTAPI = 'sanbrcdrestapi',
  SANCISCO = 'sancisco',
  SANNAV = 'sannav',

  // LAN
  LANOTHERS = 'lanothers',
  LANCISCO = 'lancisco',
  FIREWALLCISCO = 'firewallcisco',
  FORTIGATE = 'fortigate',
  FORTISWITCH = 'fortiswitch',

  // Container
  KUBERNETES = 'kubernetes',
  OPENSHIFT = 'openshift',
  DOCKER = 'docker',
  TANZU = 'tanzu',

  // Cloud
  AZURE = 'azure',
  AWS = 'aws',
  GCLOUD = 'gcloud',
  IBMCLOUD = "ibmcloud",
  SKYTAP = "skytap",

  //Backup
  IBMTSM = 'ibmtsm',
  VEEAM = 'veeam',
  VEEAMBR = 'veeambr',
  COMMVAULT = 'commvault',

  // Tape
  IBMTS2900 = 'ibmts2900',
  IBMTS3500 = 'ibmts3500',
  IBMTS4300 = 'ibmts4300',
  IBMTS4500 = 'ibmts4500',
  QUANTUMSCALAR = 'quantumscalar',

  // GPU
  //NVIDIA = "nvidia",

  //hwTypes added for vendors.constants

  INFINIGUARD = "infiniguard",
  VTRAK = "vtrak",
  EQUALOGIC = "equalogic",

}
